import { Question } from '@phosphor-icons/react';
import Tooltip from './Tooltip';

// Botón flotante que abre el recorrido guiado de la vista actual (ver useGuidedTour).
const TourButton = ({ onClick }) => (
  <div data-tour="tour-button" className="fixed bottom-4 right-4 z-40 rounded-full md:bottom-6 md:right-6">
    <Tooltip content="Ver recorrido de esta vista" placement="left" disableOnMobile>
      <button
        type="button"
        onClick={onClick}
        aria-label="Ver recorrido de esta vista"
        className="grid h-12 w-12 place-items-center rounded-full border border-line bg-surface-2 text-amber shadow-[0_10px_25px_rgba(0,0,0,0.45)] transition hover:scale-105 hover:border-amber md:h-[52px] md:w-[52px]"
      >
        <Question size={26} />
      </button>
    </Tooltip>
  </div>
);

export default TourButton;
